import React from 'react'
import Link from 'gatsby-link'

import Logo from './logo'

const Header = () => (
  <header className="row">
    <div className="col-sm-1 col-xs-1 col-xs-offset-1">
      <Link
        to="/">
          <Logo / >
      </Link>
    </div>
    <nav className="col-sm-offset-2 col-xs-offset-1 col-sm-8 col-xs-10 main-menu" id="main-menu">
      <ul>
        <li>
          <Link
            to="/"
          >
            About
          </Link>
        </li>
        <li className="aosphere">
          <Link
            to = "/aosphere"
          >
            aosphere
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
          >
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js